<template>
  <Header header__white="header__white" />
  <Breadcrumb title="İletişim" subtitle="İletişim" />
  <ContactArea/>
  <Footer footerPadding="true"/>
</template>

<script>
import Header from '../components/Home/Header.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
import ContactArea from '../components/Contact/ContactArea.vue';
import Footer from '../components/Home/Footer.vue';
import { useSeo } from '@/composables/useSeo';

export default {
   name:'ContactPage',
   components:{
		Header,
      Breadcrumb,
      ContactArea,
      Footer,
	},
    setup() {
        useSeo({
            title: 'İletişim',
            description: 'GelişimP Türkiye ile iletişime geçin. Eğitim, seminer ve iş birliği talepleriniz için bize ulaşın.',
            url: '/contact',
            type: 'website'
        })
    }
}
</script>
